import { render, staticRenderFns } from "./FileTree.vue?vue&type=template&id=27e47996&scoped=true"
import script from "./FileTree.vue?vue&type=script&lang=js"
export * from "./FileTree.vue?vue&type=script&lang=js"
import style0 from "./FileTree.vue?vue&type=style&index=0&id=27e47996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e47996",
  null
  
)

export default component.exports